import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = mode === "login"
        ? await api.post("/auth/login", { email, password })
        : await api.post("/auth/register", { name, email, password });
      login(data);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex bg-[#0A0A0A]">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-14 border-r border-[#D4AF37]/20">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">Do The Work Consulting Group</p>
        <div>
          <h1 className="font-display text-5xl xl:text-6xl font-black tracking-tight text-[#FDFBF7] leading-[1.05]">
            One enterprise.<br />One integrated<br /><span className="text-[#D4AF37]">operating model.</span>
          </h1>
          <p className="text-white/60 mt-6 max-w-md text-sm leading-relaxed">
            Map every department, capability, workflow, role, system, data object and control —
            then generate an evidence-based recommended integrated operating model and a six-phase AI transformation roadmap.
          </p>
        </div>
        <div className="grid grid-cols-3 gap-4 text-white/50 text-xs">
          <div><span className="font-display text-2xl text-[#D4AF37] block">6</span>operating-model dimensions</div>
          <div><span className="font-display text-2xl text-[#D4AF37] block">6</span>transformation phases</div>
          <div><span className="font-display text-2xl text-[#D4AF37] block">1</span>traceable enterprise system</div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8 bg-[#FDFBF7]">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4 fade-up" data-testid="login-form">
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">Enterprise Engineering Navigator™</p>
            <h2 className="font-display text-3xl font-bold tracking-tight mt-1">{mode === "login" ? "Sign in" : "Create account"}</h2>
          </div>
          {mode === "register" && (
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" required data-testid="register-name-input"
              className="w-full border border-black/15 bg-white rounded-sm px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-[#D4AF37]" />
          )}
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email" required data-testid="login-email-input"
            className="w-full border border-black/15 bg-white rounded-sm px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-[#D4AF37]" />
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Password" required data-testid="login-password-input"
            className="w-full border border-black/15 bg-white rounded-sm px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-[#D4AF37]" />
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit-btn"
            className="w-full bg-[#0A0A0A] text-[#D4AF37] font-semibold py-2.5 rounded-sm text-sm hover:bg-black/85 transition-colors disabled:opacity-60">
            {loading ? "Please wait…" : mode === "login" ? "Sign in" : "Create account"}
          </button>
          <button type="button" data-testid="toggle-auth-mode-btn" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
            className="w-full text-xs text-black/50 hover:text-black transition-colors">
            {mode === "login" ? "New here? Create an account" : "Already have an account? Sign in"}
          </button>
          <p className="text-[11px] text-black/40 border-t border-black/10 pt-3">Demo access: admin@dtw.com / DTWnavigator2026</p>
        </form>
      </div>
    </div>
  );
}
